import { render, staticRenderFns } from "./highisk.vue?vue&type=template&id=66128eb1&scoped=true&"
import script from "./highisk.vue?vue&type=script&lang=js&"
export * from "./highisk.vue?vue&type=script&lang=js&"
import style0 from "./highisk.vue?vue&type=style&index=0&id=66128eb1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66128eb1",
  null
  
)

export default component.exports